import { useQuery } from '@tanstack/react-query';
import { getFeaturedChannels } from '../services/api';
import type { Channel } from '../types';

export function useFeaturedChannels(enabled: boolean = true) {
    console.log(
        '[PAIR-APP] useFeaturedChannels hook called with enabled:',
        enabled
    );

    return useQuery({
        queryKey: ['featuredChannels'],
        enabled: enabled,
        queryFn: async (): Promise<Channel[]> => {
            console.log(
                '[PAIR-APP] useFeaturedChannels - Fetching from API...'
            );
            const response = await getFeaturedChannels();
            console.log(
                '📡 useFeaturedChannels hook - API response:',
                response
            );

            const channels = response.data || [];
            console.log(
                '📡 useFeaturedChannels hook - Channels to return:',
                channels
            );

            // Log details about each channel
            channels.forEach((channel) => {
                console.log(`  📺 Channel "${channel.name}":`, {
                    id: channel.id,
                    artworksCount: channel.artworks?.length || 0,
                    hasCollections: !!(channel as any).collections?.length,
                    collectionsCount: (channel as any).collections?.length || 0,
                });
            });

            return channels as Channel[];
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
        refetchOnWindowFocus: false, // Prevent refetch when window regains focus
        refetchOnMount: false, // Prevent refetch when component mounts if data exists
        refetchOnReconnect: false, // Prevent refetch on reconnect
    });
}
